import { useEffect, useState } from "react";
import { ScreenLoader } from "../components/loader/index.js";
import { useMe } from "../lib/queries/index.js";
import { safeNext } from "../lib/sign-in-path.js";
import { navigate } from "../lib/url-filters.js";
import { SignInScreen } from "./sign-in-screen.js";

/**
 * `/sign-in`: the form for someone signed out, and a way through for someone
 * who is not.
 *
 * Signing in with a password refreshes the session query; the moment it says
 * someone is here, this page forwards to `next`, so there is one place that
 * decides where a new session lands.
 */
export function SignInRoute() {
  const me = useMe(true);
  // Read once, as the page opens. Read on every render, it changed under the
  // redirect itself: the address had already moved to `next`, so the next
  // render found no `next` and sent the person to the Overview instead.
  const [next] = useState(() =>
    safeNext(new URLSearchParams(window.location.search).get("next")),
  );
  const signedIn = me.data !== undefined && me.data !== null;

  // Navigation, not data fetching: the session query above is the fetch.
  useEffect(() => {
    if (signedIn) navigate(next, { replace: true });
  }, [signedIn, next]);

  if (me.isPending || signedIn) {
    return <ScreenLoader caption="Checking your session" />;
  }
  if (me.isError) {
    return (
      <div className="page">
        <div className="container narrow">
          <div className="notice notice-error">
            Could not check your session: {me.error.message}. Try again in a moment.
          </div>
        </div>
      </div>
    );
  }
  return <SignInScreen />;
}
